import React, { useState } from "react";
import { FaSearch, FaTimes, FaBars } from "react-icons/fa"; // Import FaBars
import axios from "axios";
import "./MainNav.css";
import logo from "../assets/icons/logo.png";

const MainNav = () => {
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // New state for dropdown

  const toggleSearch = () => {
    setIsSearchActive(!isSearchActive);
    setSearchQuery("");
    setSearchResults([]);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://khanehyeghtesad.com:8000/api/article/search/",
        {
          search_phrase: searchQuery,
          page_number: 1,
        }
      );
      setSearchResults(response.data.articles || []);
    } catch (error) {
      console.error("Error fetching search results:", error);
    }
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen); // Toggle dropdown visibility
  };

  // If you need scroll-to-section on desktop, keep these
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav className="main-nav">
      <div className="container">
        {/* If search is active, show the search container; else show the normal nav */}
        {isSearchActive ? (
          <div className="search-container">
            <form onSubmit={handleSearchSubmit} className="search-form-inline">
              <input
                type="text"
                value={searchQuery}
                onChange={handleSearchChange}
                placeholder="جستجو"
              />
              <button
                type="button"
                className="close-search"
                onClick={toggleSearch}
              >
                <FaTimes />
              </button>
            </form>
          </div>
        ) : (
          <>
            {/* 1) Logo on the right side */}
            <div className="col col-logo">
              <div className="logo-container">
                <a href="/">
                  <img src={logo} alt="خانه اقتصاد" />
                  <span className="logo-text">پایگاه خبری تحلیلی خانه اقتصاد</span>
                </a>
              </div>
            </div>

            {/* 2) (Desktop) Nav Links - hidden on mobile */}
            <div className="col col-nav">
              <ul className="nav-links-main">
                <li className="active">
                  <a href="/">خانه</a>
                </li>
                <li>
                  <a href="#footer" onClick={() => scrollToSection("about")}>
                    درباره ما
                  </a>
                </li>
                <li>
                  <a href="#footer" onClick={() => scrollToSection("contact")}>
                    تماس با ما
                  </a>
                </li>
                <li>
                  <a href="#videos" onClick={() => scrollToSection("videos")}>
                    ویدیو
                  </a>
                </li>
                <li>
                  <a
                    href="#latest-news"
                    onClick={() => scrollToSection("latest-news")}
                  >
                    آخرین اخبار
                  </a>
                </li>
                {/* New menu item for "روزنامه چارسوق" */}
                <li>
                  <a href="/charsooq">روزنامه چارسوق</a>
                </li>
              </ul>
            </div>

            {/* 3) Search Icon on the left side (mobile) or next to nav (desktop) */}
            <div className="col col-search">
              <div className="search-icon" onClick={toggleSearch}>
                <FaSearch />
              </div>
            </div>
          </>
        )}

        {/* Mobile Hamburger Menu (three lines) */}
        <div className="col col-dropdown">
          <button className="dropdown-toggle" onClick={toggleDropdown}>
            <FaBars /> {/* Hamburger icon */}
          </button>
          {isDropdownOpen && (
            <div className="dropdown-menu">
              <div className="search-container">
                <form onSubmit={handleSearchSubmit} className="search-form-inline">
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    placeholder="جستجو"
                  />
                </form>
              </div>
              <a href="/charsooq" className="dropdown-item">روزنامه چارسوق</a>
            </div>
          )}
        </div>
      </div>

      {/* Display search results below */}
      {isSearchActive && searchResults.length > 0 && (
        <div className="search-results">
          <ul>
            {searchResults.map((result) => (
              <li key={result._id}>
                <a href={`/article/${result.slug}`}>
                  <h3>{result.title}</h3>
                  <p>{result.caption}</p>
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
};

export default MainNav;
